<div class="container-fluid p-3 m-0" [class.hide-pointer]="hidePointer" style="overflow-x: auto; overflow-y: hidden">
    <div class="row pt-2 justify-content-end">
        <div class="col-4" *ngIf="showSearch">
            <mat-form-field appearance="outline" class="search-bar">
                <mat-label class="search-bar-label">
                    <mat-icon class="search-icon">search</mat-icon>
                    <span>Search</span>
                </mat-label>
                <input matInput (keyup.enter)="onSearchEvent($event)" (keyup.backspace)="onDeleteKeyUp()" [(ngModel)]="searchKeyword">
                <button type="button" *ngIf="searchKeyword" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="d-flex flex-row align-items-center pt-2" id="filter-pills-container">
        <app-data-table-filter-pill 
            *ngFor="let filterPill of filterPills | keyvalue" 
            [filterState]="filterPill.value" 
            (closeClickEvent)="onFilterPillCloseEvent($event)" 
            [disable]="displayLoadingIndicator">
        </app-data-table-filter-pill>
    </div>
    <div class="mt-2 mb-3">
        <div class="table-responsive">
            <table mat-table matSort [dataSource]="_dataSource" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                    <ng-container *ngIf="column.column !== 'action'">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                    </ng-container>
                    <ng-container *ngIf="column.column === 'action'">
                        <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                    </ng-container>
                    <ng-container [ngSwitch]="column.column">
                        <ng-container *ngSwitchCase="'action'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <button mat-raised-button class="action-button"
                                        (click)="onActionButtonClick($event, element)">{{ actionButtonText }}</button>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'pillStatus'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <app-pill [backgroundColor]="this.getColor(element[column.column])" fontColor="white"
                                        [text]="element[column.column]"></app-pill>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onRowClick(row)" [ngClass]="{'highlight': selectedRowIndex === row}"></tr>
                @if(displayLoadingIndicator && searchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            No data matching the filter "{{ searchKeyword }}"
                        </td>
                    </tr>
                }
                @if (displayLoadingIndicator && !searchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            Loading Organizations..
                        </td>
                    </tr>
                }
            </table>
        </div>
        <div *ngIf="displayLoadingIndicator.value" class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
        <div class="d-flex paginator-row align-items-baseline" *ngIf="showPaginator">
            <div class="col-10">
                <mat-paginator 
                    (page)="onPageEvent($event)" 
                    [pageSizeOptions]="this.disablePageSizeSelector ? [] : [10, 20, 50, 100]" 
                    [length]="tableLength"
                    [pageSize]="pageSize || 5" 
                    aria-label="Select page"
                    showFirstLastButtons
                >
                </mat-paginator>
            </div>
            <div class="col-2 d-flex align-items-baseline">
                <mat-form-field class="go-to" id="goToPage">
                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber">
                </mat-form-field>
                <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
            </div>
        </div>
    </div>
</div>